import { PostThumbnailType } from '../types/postsType';

export const postsDataMapper = (data: PostThumbnailType) => {
  const extractType = data?.postType?.type;
  return { ...data, type: extractType };
};
